(function() {
    const archiveEl = document.querySelector('.jsDownloadArchive');
    let archiveGrid = null;
    let searchTimeout = null;
    let searchQuery = '';

    if (archiveEl) {
        archiveGrid = archiveEl.querySelector('.jsArchiveGrid');

        const downloadTypeFilterEl = archiveEl.querySelector('.jsDownloadTypeFilter');
        if (downloadTypeFilterEl) {
            const downloadTypeSelect = new SeSelect(downloadTypeFilterEl, 'type');
            downloadTypeSelect.setActiveOptions(activeDownloadTypes);

            downloadTypeSelect.addChangeEventListener(newOptions => {
                activeDownloadTypes = Object.keys(newOptions);
                updateGrid();
            });
        }

        const themeFilterEl = archiveEl.querySelector('.jsThemeFilter');
        if (themeFilterEl) {
            const themeSelect = new SeSelect(themeFilterEl, 'theme');
            themeSelect.setActiveOptions(activeThemes);

            themeSelect.addChangeEventListener(newOptions => {
                activeThemes = Object.keys(newOptions);
                updateGrid();
            });
        }

        const programFilterEl = archiveEl.querySelector('.jsProgramFilter');
        if (programFilterEl) {
            const programSelect = new SeSelect(programFilterEl, 'program');
            programSelect.setActiveOptions(activePrograms);

            programSelect.addChangeEventListener(newOptions => {
                activePrograms = Object.keys(newOptions);
                updateGrid();
            });
        }

        const searchFormEl = archiveEl.querySelector('.jsSearchFilter');
        if (searchFormEl) {
            const searchInputEl = searchFormEl.querySelector('input');

            searchFormEl.addEventListener('submit', e => {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });

            searchInputEl.addEventListener('keyup', e => {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });
        }
    }

    function userDidSearch(query) {
        searchQuery = query;

        // Update the URL
        const url = new Url;

        if (searchQuery) url.query.search = searchQuery;
        else delete url.query.search;

        history.pushState(null, null, url.toString());

        // Set a timeout
        if (searchTimeout) clearTimeout(searchTimeout);
        searchTimeout = setTimeout(_ => updateGrid(), 500);
    }

    function updateGrid() {
        const params = {
            action: 'get_download_grid_html',
            activeDownloadTypes: activeDownloadTypes,
            activeThemes: activeThemes,
            activePrograms: activePrograms,
            searchQuery: searchQuery
        };

        if (typeof activeYears !== 'undefined') params.activeYears = activeYears;
        if (typeof activeThemes !== 'undefined') params.activeThemes = activeThemes;
        if (typeof activePrograms !== 'undefined') params.activePrograms = activePrograms;

        se_postRequest(se_ajax.ajaxurl, params, response => {
            response = JSON.parse(response);

            if (!response.err) {
                archiveGrid.innerHTML = response.html;
            }
            else {
                alert('Oops.. Something went wrong. Please reload the page and try again.');
                return;
            }

        }, _ => {
            alert('Oops.. Something went wrong. Please reload the page and try again.');
            return;
        });
    }
})();
